import { Typography, Card, Divider } from "antd";

const { Title, Paragraph, Text, Link } = Typography; // Link se obtiene de Typography

export default function DeleteAccount() {
  return (
    <div className="admin-static-page">
      <Card bordered>
        <Typography>
          <Title level={2}>
            Eliminación de cuenta – Swingers VIP
          </Title>

          <Paragraph>
            En <Text strong>Swingers VIP</Text> respetamos tu privacidad. 
            Si deseas eliminar tu cuenta y todos los datos asociados, 
            por favor contacta a nuestro equipo de soporte.
          </Paragraph>

          <Divider />

          <Title level={3}>Pasos para eliminar tu cuenta</Title>
          <Paragraph>
            Envía un correo a nuestro soporte indicando que deseas eliminar tu cuenta. 
            Nuestro equipo procesará tu solicitud y eliminará todos los datos asociados.
          </Paragraph>

          <Card
            style={{
              backgroundColor: "#f0f5ff",
              borderLeft: "4px solid #1677ff",
              marginBottom: "16px",
            }}
          >
            📧 <Text strong>Email de soporte:</Text>{" "}
            <Link href="mailto:infoswingersvip@gmail.com">
              infoswingersvip@gmail.com
            </Link>
          </Card>

          <Divider />

          <Paragraph>
            Todos los datos de tu cuenta serán eliminados tras la confirmación de la solicitud, 
            incluyendo nombre de usuario, correo, mensajes y contenidos compartidos. 
            Algunos datos pueden conservarse temporalmente por motivos legales, como registros de facturación.
          </Paragraph>

          <Paragraph type="secondary" italic>
            Última actualización: diciembre 2025
          </Paragraph>
        </Typography>
      </Card>
    </div>
  );
}
